import { OyResponse } from '@oy/types';
import axios, { BUSINESS_PREFIX_V2 } from 'src/clients/axios';
import { MaintenanceScheduleConfigResponse, MaintenanceScheduleOngoingResponse, MaintenanceScheduleResponse } from 'src/models';

export const GET_MAINTENANCE_SCHEDULES_URL = `${BUSINESS_PREFIX_V2}/maintenance-schedules`;
export const GET_MAINTENANCE_SCHEDULES_ONGOING_URL = `${BUSINESS_PREFIX_V2}/maintenance-schedules/ongoing`;
export const GET_MAINTENANCE_SCHEDULES_CONFIG_URL = `${BUSINESS_PREFIX_V2}/maintenance-schedules/config`;

export function getMaintenanceSchedules() {
  return axios.request<OyResponse<MaintenanceScheduleResponse>>({
    method: 'get',
    url: GET_MAINTENANCE_SCHEDULES_URL
  });
}

export function getMaintenanceSchedulesOngoing() {
  return axios.request<OyResponse<MaintenanceScheduleOngoingResponse>>({
    method: 'get',
    url: GET_MAINTENANCE_SCHEDULES_ONGOING_URL
  });
}

export function getMaintenanceSchedulesConfig() {
  return axios.request<OyResponse<MaintenanceScheduleConfigResponse>>({
    method: 'get',
    url: GET_MAINTENANCE_SCHEDULES_CONFIG_URL
  });
}
